import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceContentsApplyRegistModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,
      processing: false,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'contentsSnapshotId',
        'snapshotName',
        'snapshotTag',
        'releaseNote',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          contentsSnapshotId: 'スナップショットID',
          snapshotName: 'スナップショット名',
          snapshotTag: 'タグ',
          releaseNote: 'リリースノート'
        },
        columnsClasses: {
          checkbox: 'wp-3',
          contentsSnapshotId: 'wp-5',
          snapshotName: '',
          snapshotTag: '',
          releaseNote: ''
        },
        sortable: [
          'contentsSnapshotId',
          'snapshotName',
          'snapshotTag',
          'releaseNote'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('スナップショット'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: null,

      // 製造番号
      inpDeviceSerial: null,

      // ロケーションのニックネーム
      locationNickname: null,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.serviceContentsApplyRegistModal.active,
      serviceId: state => state.serviceContentsApplyRegistModal.serviceId,
      serviceContentsId: state => state.serviceContentsApplyRegistModal.serviceContentsId,
      appliedContentsId: state => state.serviceContentsApplyRegistModal.targetId,

      // model
      contentsSettingModel: state => state.serviceContentsApply.contentsSettingModel,
      contentsApplyModel: state => state.serviceContentsApply.contentsApplyModel,
      snapshotModel: state => state.serviceContentsApplyRegistModal.snapshotModel,
      serviceAttributeModel: state => state.serviceContentsApplyRegistModal.serviceAttributeModel,
      values: state => state.serviceContentsApplyRegistModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      isRegister: 'serviceContentsApplyRegistModal/isRegister',
      isModify: 'serviceContentsApplyRegistModal/isModify',
    }),

    // result
    resultLocation () {
      return this.locationNickname || '未選択'
    },

    // list
    deliveryToList () {
      return Constants.ContentsApply.DeliveryToKbn
    },
    attributeList () {
      let list = []
      this.serviceAttributeModel.forEach(type => {
        type.attributeGroups.forEach(group => {
          if (group.attributeGroupCode) {
            const label = type.attributeTypeName + ' : ' + group.attributeGroupName
            list.push({
              value: group.attributeGroupUuid,
              label: label
            })
          }
        })
      })
      return list
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // result
    resultContentId () {
      try {
        return this.isRegister ?
          this.contentsSettingModel.filter(item => item.serviceContentsUuid === this.serviceContentsId)[0].serviceContentsId :
          this.contentsApplyModel.filter(item => item.appliedContentsUuid === this.appliedContentsId)[0].serviceContentsId
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },
    resultDevice () {
      try {
        return this.isRegister ?
          this.contentsSettingModel.filter(item => item.serviceContentsUuid === this.serviceContentsId)[0].serviceType :
          this.contentsApplyModel.filter(item => item.appliedContentsUuid === this.appliedContentsId)[0].deviceType
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // input
    inpDeliberyToKbn: {
      get () {
        return this.values.inpDeliberyToKbn
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliberyToKbn',
          value: value
        })
      }
    },
    inpLocation: {
      get () {
        return this.values.inpLocation
      },
      set (value) {
        this.setInputValue({
          key: 'inpLocation',
          value: value
        })
      }
    },
    inpAttribute: {
      get () {
        return this.values.inpAttribute
      },
      set (value) {
        this.setInputValue({
          key: 'inpAttribute',
          value: value
        })
      }
    },
    inpSnapshot: {
      get () {
        return this.values.inpSnapshot
      },
      set (value) {
        this.setInputValue({
          key: 'inpSnapshot',
          value: value
        })
      }
    },

    // disabled
    disableSearchButton () {
      return this.inpDeviceSerial === null ||
        this.inpDeviceSerial === ''
    },
    disableConfirmButton () {
      if (this.inpDeliberyToKbn === null) return true
      if (this.checkList === null) return true
      return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    inpDeliberyToKbn: function (to) {
      
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceContentsApplyRegistModal/loadModel',
      hide: 'serviceContentsApplyRegistModal/hide',
      setUpdated: 'serviceContentsApplyRegistModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'serviceContentsApplyRegistModal/setInputValue',
    }),

    init () {
      this.loading = true

      // データ更新フラグの初期化
      this.setUpdated(false)

      //
      let contentsSettingParams = {
        serviceUuid: this.serviceId,
        serviceContentsUuid: this.serviceContentsId
      }
      let serviceAttributeParams = {
        serviceUuid: this.serviceId
      }
      let contentsApplyParams = {
        serviceUuid: this.serviceId,
        appliedContentsUuid: this.appliedContentsId
      }

      // データ読出し
      this.loadModel({
        contentsSettingParams: contentsSettingParams,
        serviceAttributeParams: serviceAttributeParams,
        contentsApplyParams: contentsApplyParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.snapshotModel)

          // 個別配信で登録済みの場合
          if (this.values.deliveryToLocationDeviceSerial) {
            this.locationNickname = this.values.deliveryToLocationDeviceSerial
            // this.searchLocation()
          }

          // 選択済みスナップショットIDをチェックリストに格納
          if (this.values.contentsSnapshot &&
            this.values.contentsSnapshot.contentsSnapshotUuid) {
            this.checkList = this.values.contentsSnapshot.contentsSnapshotUuid
          }
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.contentsSnapshotUuid
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },
    
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容で適用コンテンツを登録しますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      console.log('check : ', this.checkList)

      this.processing = true

      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          deliberyToKbn: this.inpDeliberyToKbn,
          contentsSnapshotUuid: this.checkList
        }
      }
      if (this.isModify) {
        parameters.appliedContentsUuid = this.appliedContentsId
      }
      if (this.inpDeliberyToKbn === 1) {
        parameters.request.deliveryToAttributeGroupUuids = this.inpAttribute
      }
      if (this.inpDeliberyToKbn === 2) {
        parameters.request.deliveryToLocationUuid = this.inpLocation
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceContentsApply'],
        [this.isRegister
          ? 'v1ServiceContentsApplyPost'
          : 'v1ServiceContentsApplyPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '適用コンテンツの登録',
              body: '適用コンテンツを登録しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    searchLocation () {
      this.processing = true

      let parameters = {
        deviceSerial: this.inpDeviceSerial,
        filters: {
          serviceUuid: this.serviceId
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['community'],
        ['v1LocationNicknameGet'],
        [parameters])
        .then(res => {
          console.log(res)
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.locationNickname = res[0].data.nickName
            if (this.inpLocation !== res[0].data.locationUuid) {
              this.inpLocation = res[0].data.locationUuid
            }

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}